var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.app.isLoadingPage)?_c('div',[_c('v-row',[_c('v-col',{staticClass:"align-self-end",attrs:{"cols":"12","md":"12","sm":"12","order":"1"}},[_c('h3',[_vm._v("Dashboard")])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }